import * as React from "react";
const SvgHandicapAccess = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.772 4.022a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm1.25-2.75a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM6.797 9.596a.75.75 0 0 0-.764-1.29 7.752 7.752 0 0 0 5.129 14.33 7.749 7.749 0 0 0 6.135-5.103.75.75 0 1 0-1.415-.496 6.25 6.25 0 1 1-9.085-7.441Zm1.926-2.262a.75.75 0 0 1 .986.389l1.12 2.574a.754.754 0 0 1 .193-.025h5.5a.75.75 0 0 1 0 1.5H11.47l.652 1.5h6.29a.75.75 0 0 1 .689.45l2.608 6a.75.75 0 1 1-1.375.599l-2.413-5.55h-6.29a.75.75 0 0 1-.688-.45l-2.61-6a.75.75 0 0 1 .39-.987Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgHandicapAccess;
